import { render, staticRenderFns } from "./Year08.vue?vue&type=template&id=47649b7d&scoped=true&"
import script from "./Year08.vue?vue&type=script&lang=js&"
export * from "./Year08.vue?vue&type=script&lang=js&"
import style0 from "./Year08.vue?vue&type=style&index=0&id=47649b7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47649b7d",
  null
  
)

export default component.exports